class ImageSlider extends HTMLElement {
  constructor() {
    super();
    this.swiperSelector = this.getAttribute('swiper-selector') || '.swiper-container-image-slider';
    this.onlyMobile = this.hasAttribute('only-mobile');
    this.breakpoint = parseInt(this.getAttribute('breakpoint') || 768);
    this.autoplay = this.hasAttribute('autoplay');
    this.lazyInit = this.hasAttribute('lazy-init');

    this._observer = null;   
    this._swiper = null;    
  }

  connectedCallback() {
    if (this.lazyInit) {
      this.initObserver();
    } else {
      this.initSwiper();
    }
  }

  disconnectedCallback() {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }

    if (this._swiper && typeof this._swiper.destroy === 'function') {
      try {
        this._swiper.destroy(true, true);
      } catch (err) {
        /* noop */
      }
      this._swiper = null;
    }
  }

  initObserver() {
    this._observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.initSwiper();
          this._observer.disconnect();
          this._observer = null;
        }
      });
    });
    this._observer.observe(this);
  }

  initSwiper() {
    const swiperEl = this.querySelector(this.swiperSelector);
    if (!swiperEl || swiperEl.dataset.initialized === 'true') return;
    swiperEl.dataset.initialized = 'true';

    try {
      if (window.swiperManager) {
        this._swiper = new window.swiperManager(this.swiperSelector, {
          onlyMobile: this.onlyMobile,
          breakpoint: this.breakpoint,
          swiper: {
            slidesPerView: 3,
            loop: true,
            speed: 800,
            autoplay: this.autoplay
              ? {
                  delay: 3500,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: false,
                }
              : false,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
          },
        });
      }

      else if (window.Swiper) {
        this._swiper = new Swiper(swiperEl.querySelector('.swiper'), {
          slidesPerView: 3,
          loop: true,
          speed: 800,
          autoplay: this.autoplay
            ? {
                delay: 3500,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
              }
            : false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        });
      } else {
      }
    } catch (err) {
      console.error('[ImageSlider] Failed to init Swiper:', err);
    }
  }
}

customElements.define('image-slider', ImageSlider);
